import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  couponData: null,
};

export const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setCouponData: (state, action) => {
      state.couponData = action.payload;
    },
  },
});

export const { setCouponData } = checkoutSlice.actions;

export default checkoutSlice.reducer;
